import { createContext } from '@lit/context';
import type { Product } from '@repobit/dex-store';

export type productContextType = Product | null | undefined;
export const productContext = createContext<productContextType>(Symbol('product'));

